export default __webpack_public_path__ + "static/media/contact-header-mobile.aaa8b0e0.png";